import React from 'react';
import { CellProps } from 'antd/lib/descriptions/Cell';

export type AppCellProps = CellProps & {
    children: React.ReactNode;
    content?: string;
    accessibilityLabel?: string;
};

export const AppBodyCell = ({
    children,
    accessibilityLabel,
    ...wrapperDefaultProps
}: AppCellProps) => (
    <td {...wrapperDefaultProps} aria-label={accessibilityLabel}>
        {/*TODO: to change, because at this moment there is error: "validateDOMNesting(...): <tbody> cannot appear as a child of <span>"*/}
        <span className="cell-content">{children}</span>
    </td>
);
